module.exports = __webpack_public_path__ + "img/dsci0062.de2a1acc.jpg";